import React from "react";
import Slider from "react-slick";

export default function HomeTestimonial({ data = [], extraClass = "" }) {

  const settings = {
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: true,
    infinite: true,
    pauseOnHover: true,
    arrows: false,
    centerPadding: "0px",
    autoplaySpeed: 3000,
    speed: 3000,
    cssEase: "ease",
     customPaging: function () {
      return <button className="custom-dot"></button>;
    },

    responsive: [
      {
        breakpoint: 993,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },


    ],
  };

  return (
    <>
    
  
    <div className={`home-testimonial ${extraClass}`}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-7">
            <div className="services-text">
              <h2 className="heading">We Made Cleanups Easy, <br/> Just Ask Them</h2>
            </div>
          </div>
        </div>

        <Slider {...settings} className="testimonial-sliders">
          {data.map((item, index) => (
            <div className="sliders-cols" key={index}>
              <div className="sliders-cols-inner">
                <div className="rating">
                  {Array.from({ length: item.rating }).map((_, i) => (
                    <i className="fa-solid fa-star" key={i}></i>
                  ))}
                </div>

                <div className="testimonial-content">  <p>{item.text}</p> </div>
                <div className="testimonial-authors">
                  {/* <div className="authors-img">  <img src={item.img} className="img-responsive" alt={item.name} loading="lazy" />  </div> */}
                  <div className="authors-content">
                    <div className="name">{item.name}</div>
                    <div className="des">{item.des}</div>
                  </div>
               <img src="/assets/images/home-quotes.webp" className="img-responsive quotes-img" alt="Quotes" loading="lazy"/>
                </div>

              </div>
            </div>
          ))}
        </Slider>

      </div>
    </div>  
    
    </>
  );
}
